import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { useDispatch, useSelector } from "react-redux";
import TableDataComponent from "../../components/parking-excel/TableDataComponent";
import TotalLineComponent from "../../components/parking-excel/TotalLineComponent";
import { setLayoutDashboardTitle } from "../../store/ui-slice";
import { useNavigate } from "react-router-dom";
import useAPIRequest from "../../custom_hooks/simple/useAPIRequest";
import { format, set } from "date-fns";
import { Dropdown } from "primereact/dropdown";
import copyToClipboard from "../../utils/parkir-import-excel/CopyToClipboard";
import onSuccessToast from "../../utils/OnSuccessToast";
import TableAutoComponent from "../../components/complex/crud/TableAutoComponent";
import generateTableConfigs from "../../utils/TableConfigGenerator";

const title = "Laporan Parkir";

const filterOptions = [
  { name: "Semua", value: "semua" },
  { name: "Mentah", value: "mentah" },
  { name: "Edited", value: "edited" },
];

const configs = [
  // add_configs
  {
    name: "#",
    field: "no",
    type: "text_plain",
    table: true,
    filter: true,
    editor: true,
  },
  {
    name: "Tanggal",
    field: "tanggal",
    type: "text_plain",
    table: true,
    filter: true,
    editor: true,
  },
  {
    name: "Mobil",
    field: "total_mobil",
    type: "number_plain",
    align: "right",
    table: true,
    filter: true,
    editor: true,
  },
  {
    name: "S. Motor",
    field: "total_sepeda",
    type: "number_plain",
    align: "right",
    table: true,
    filter: true,
    editor: true,
  },
  {
    name: "Total",
    field: "total",
    type: "number_plain",
    align: "right",
    table: true,
    filter: true,
    editor: true,
  },
  {
    name: "Mobil (E)",
    field: "total_edited_mobil",
    type: "number_plain",
    align: "right",
    table: true,
    filter: true,
    editor: true,
  },
  {
    name: "S. Motor (E)",
    field: "total_edited_sepeda",
    type: "number_plain",
    align: "right",
    table: true,
    filter: true,
    editor: true,
  },
  {
    name: "Total (E)",
    field: "total_edited",
    type: "number_plain",
    align: "right",
    table: true,
    filter: true,
    editor: true,
  },
];

const sourceTableConfig = generateTableConfigs(configs);

const LaporanHarianPage = (props) => {
  const navigate = useNavigate();
  const permissions = useSelector((state) => state.auth.permissions);

  const toastRef = useRef(null);
  const dispatch = useDispatch();
  const [tableConfigs, setTableConfigs] = useState(sourceTableConfig);
  const [date, setDate] = useState([new Date(), new Date()]);
  const [data, setData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(filterOptions[1].value);
  const [totalMobil, setTotalMobil] = useState(0);
  const [totalSepeda, setTotalSepeda] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalEditedMobil, setTotalEditedMobil] = useState(0);
  const [totalEditedSepeda, setTotalEditedSepeda] = useState(0);
  const [totalEdited, setTotalEdited] = useState(0);

  const { requestGet, loading } = useAPIRequest();

  useEffect(() => {
    if (!permissions.includes("view editdata")) {
      navigate("/");
    }
    dispatch(setLayoutDashboardTitle({ title }));

    // reloadData();
  }, []);

  useEffect(() => {
    if (selectedFilter === "semua") {
      setTableConfigs(sourceTableConfig);
    } else if (selectedFilter === "mentah") {
      setTableConfigs(
        sourceTableConfig.filter(
          (config) =>
            config.field !== "total_edited_mobil" &&
            config.field !== "total_edited_sepeda" &&
            config.field !== "total_edited"
        )
      );
    } else if (selectedFilter === "edited") {
      setTableConfigs(
        sourceTableConfig.filter(
          (config) =>
            config.field !== "total_mobil" &&
            config.field !== "total_sepeda" &&
            config.field !== "total"
        )
      );
    }
  }, [selectedFilter]);

  const handleCopyData = () => {
    copyToClipboard({
      fields: [
        "no",
        "tanggal",
        "total_mobil",
        "total_sepeda",
        "total",
        "total_edited_mobil",
        "total_edited_sepeda",
        "total_edited",
      ],
      data,
    });
    onSuccessToast({
      toast: toastRef,
      message: "Data berhasil di-copy",
      data: {},
    });
  };

  const generateFilter = () => {
    let filter = "";
    let firstDate, secondDate;
    if (date.length > 0) {
      firstDate = date[0];
    }
    if (date.length > 1) {
      secondDate = date[1];
    }

    if (firstDate && secondDate) {
      const nextDate = new Date(secondDate);
      nextDate.setDate(nextDate.getDate() + 1);
      filter += `keluar_tanggal:>=:${format(
        firstDate,
        "yyyy-MM-dd"
      )} 00:00:00;keluar_tanggal:<:${format(nextDate, "yyyy-MM-dd")} 00:00:00;`;
    } else if (firstDate) {
      const nextDate = new Date(firstDate);
      nextDate.setDate(nextDate.getDate() + 1);
      filter += `keluar_tanggal:>=:${format(
        firstDate,
        "yyyy-MM-dd"
      )} 00:00:00;keluar_tanggal:<:${format(nextDate, "yyyy-MM-dd")} 00:00:00;`;
    }

    // if (selectedFilter) {
    //   if (selectedFilter === "semua") {
    //     filter += ";jumlah_edited:>:0";
    //   } else if (selectedFilter === "mentah") {
    // filter += ";jumlah_edited:>:0";

    //   } else if (selectedFilter === "edited") {
    //   }
    // }

    return filter;
  };

  const reloadData = () => {
    setData([]);
    setTotalMobil(0);
    setTotalSepeda(0);
    setTotal(0);
    setTotalEditedMobil(0);
    setTotalEditedSepeda(0);
    setTotalEdited(0);

    const filter = generateFilter();
    if (!filter) {
      return;
    }

    requestGet({
      fullUrl: "api/laporan",
      params: {
        filter,
        page: 1,
        take: 1000000,
        order: "id",
        order_method: "ASC",
        prefix: "daily",
      },
      onSuccess: ({ pagination, message, data }) => {
        if (data) {
          let totalMobil = 0;
          let totalSepeda = 0;
          let total = 0;
          let totalEditedMobil = 0;
          let totalEditedSepeda = 0;
          let totalEdited = 0;

          for (let i = 0; i < data.length; i++) {
            data[i].no = i + 1;
            data[i].id = i + 1;

            totalMobil += data[i].total_mobil;
            totalSepeda += data[i].total_sepeda;
            total += data[i].total;
            totalEditedMobil += data[i].total_edited_mobil;
            totalEditedSepeda += data[i].total_edited_sepeda;
            totalEdited += data[i].total_edited;
          }

          setData(data);
          setTotalMobil(totalMobil);
          setTotalSepeda(totalSepeda);
          setTotal(total);
          setTotalEditedMobil(totalEditedMobil);
          setTotalEditedSepeda(totalEditedSepeda);
          setTotalEdited(totalEdited);
        }
      },
      onError: ({ message, data }) => {},
    });
  };

  const reloadHandler = (event) => {
    reloadData();
  };

  const TotalComponent = (props) => {
    const { label, total } = props;
    return (
      <div className="row-between-center gap-3">
        <span className="font-semibold text-indigo-400">
          {label.toUpperCase()}
        </span>
        <span>{total.toLocaleString("id-ID")}</span>
      </div>
    );
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <Toast ref={toastRef} />
      <ConfirmDialog />
      <div className="elevated-card col-start-start w-full gap-4">
        {/* header - tanggal & upload */}
        <div className="row-between-center gap-3 w-full">
          <div className="row-start-center gap-2">
            <span>Tanggal</span>
            <Calendar
              className="max-w-[20rem]"
              selectionMode="range"
              value={date}
              onChange={(e) => setDate(e.value)}
              showIcon
            />
            <Button
              label="Load Data"
              icon="pi pi-refresh"
              loading={loading}
              onClick={reloadHandler}
            />
            <Dropdown
              value={selectedFilter}
              onChange={(e) => setSelectedFilter(e.value)}
              options={filterOptions}
              optionLabel="name"
              className="w-[10rem]"
            />
          </div>
          <Button label="Copy" icon="pi pi-copy" onClick={handleCopyData} />
        </div>

        {/* total mentah */}
        {(selectedFilter === "semua" || selectedFilter === "mentah") && (
          <div className="row-end-center w-full pr-4 gap-10">
            <TotalComponent label="Total Mobil" total={totalMobil} />
            <TotalComponent label="Total Sepeda" total={totalSepeda} />
            <TotalComponent label="Total" total={total} />
          </div>
        )}

        {/* total edited */}
        {(selectedFilter === "semua" || selectedFilter === "edited") && (
          <div className="row-end-center w-full pr-4 gap-10">
            <TotalComponent label="Total Mobil (E)" total={totalEditedMobil} />
            <TotalComponent
              label="Total Sepeda (E)"
              total={totalEditedSepeda}
            />
            <TotalComponent label="Total (E)" total={totalEdited} />
          </div>
        )}

        {/* tabel */}
        <TableAutoComponent
          singleMode={true}
          selection={[]}
          onSelectionChange={() => {}}
          configs={tableConfigs}
          loading={loading}
          value={data}
          customColumn={[]}
        />
      </div>
    </div>
  );
};

export default LaporanHarianPage;
